import React, { useEffect, useState, useReducer } from "react";
import DynamicForm from "./screens/form/DynamicForm/DynamicForm";
import "react-datepicker/dist/react-datepicker.css";
import { formReducer } from "../context/formReducer";
import { CaptchaContainer } from './screens/captcha/CaptchaContainer';
import { fetchFormData } from '../functions/apiCalls';
import { LoadingScreen } from './components/LoadingScreen/LoadingScreen';
import { CheckLanguage, GetLanguageText } from './languages/languagesLoading';

const DynamicFormContainer = ({ session }) => {

    const [dataLoading, setLoading] = useState(true);
    const [formInfo, dispatch] = useReducer(formReducer, null);
    const [captchaInputValid, setCaptchaValid] = useState(window.location.origin.includes('app-vra-test') || window.location.origin.includes('localhost'));
    // const [captchaInputValid, setCaptchaValid] = useState(false);
    const [error, setError] = useState(null);
    const [esign] = useState(true);

    useEffect(() => {
        // API call with the queryString. The call (1) returns the formInfo (formID, formSpec, formType, language, orgID, etc), and (2) sets formInfo to true.
        fetchFormData(setError, setLoading, session, dispatch);
    }, [session]);

    (window.location.host.includes('localhost') && console.log("FORM INFO", formInfo));
    let languageID = "default";

    if (formInfo) {
        languageID = CheckLanguage(formInfo.dbFormSpec);
    }


    if (languageID != "default") {

        const languageText = GetLanguageText(languageID);

        return (
            <>

                {dataLoading &&
                    <LoadingScreen
                    loadingMessage={`${languageText.loading}`}
                    />
                }

                {!captchaInputValid &&
                    <CaptchaContainer
                        setCaptcha={setCaptchaValid}
                        formSpec={formInfo && formInfo.validationValues}
                        dbFormSpec={formInfo && formInfo.dbFormSpec}
                        formId={formInfo && formInfo.formId}
                    />
                }

                {formInfo &&
                    <DynamicForm
                        formInfo={formInfo}
                        formId={formInfo.formId}
                        session={session.id}
                        esign={esign}
                    />
                }

                {/* TODO; error UI */}

                {error && <LoadingScreen loadingMessage={"System is offline.  Please try again later.."} />}
            </>
        );
    }
    else {
        return (
            <>

                {dataLoading &&
                    <LoadingScreen
                        loadingMessage={"Loading the form. We'll be just a moment."}
                    />
                }

                {!captchaInputValid &&
                    <CaptchaContainer
                        setCaptcha={setCaptchaValid}
                        formSpec={formInfo && formInfo.validationValues}
                        dbFormSpec={formInfo && formInfo.dbFormSpec}
                        formId={formInfo && formInfo.formId}
                    />
                }

                {formInfo &&
                    <DynamicForm
                        formInfo={formInfo}
                        formId={formInfo.formId}
                        session={session.id}
                        esign={esign}
                    />
                }

                {/* TODO; error UI */}

                {error &&  <LoadingScreen loadingMessage={"System is offline.  Please try again later.."} />}
            </>
        );
    }
};

export default DynamicFormContainer;
